import { useEffect, useState } from "react";

import ClientTable from "../../components/clients/ClientTable";
import ClientForm from "../../components/clients/ClientForm";

import {
  getClients,
  createClient,
  updateClient,
  deleteClient
} from "../../api/clients.api";

import "../../components/clients/clientPage.css";


export default function ClientsPage() {

  // =========================
  // ÉTATS
  // =========================

  const [clients, setClients] = useState([]);

  const [clientEdit, setClientEdit] = useState(null);

  const [formOpen, setFormOpen] = useState(false);

  const [searchClient, setSearchClient] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 20;


  // =========================
  // CHARGEMENT DES CLIENTS
  // =========================

  useEffect(() => {

    loadClients();

  }, []);


  const loadClients = async () => {

    try {

      const res = await getClients();

      setClients(res.data);

    } catch (error) {

      console.error(
        "Erreur chargement clients :",
        error
      );

    }

  };


  // =========================
  // RECHERCHE
  // =========================

  const filteredClients = clients.filter((client) => {

    if (!searchClient.trim()) {
      return true;
    }

    const recherche =
      searchClient
        .toLowerCase()
        .trim();


    const nom =
      client.nom
        ? String(client.nom).toLowerCase()
        : "";


    const telephone =
      client.telephone
        ? String(client.telephone).toLowerCase()
        : "";


    const email =
      client.email
        ? String(client.email).toLowerCase()
        : "";


    const adresse =
      client.adresse
        ? String(client.adresse).toLowerCase()
        : "";


    return (

      nom.includes(recherche) ||

      telephone.includes(recherche) ||

      email.includes(recherche) ||

      adresse.includes(recherche)

    );

  });


  // =========================
  // RESET PAGE
  // =========================

  useEffect(() => {

    setCurrentPage(1);

  }, [searchClient]);


  // =========================
  // PAGINATION
  // =========================

  const totalPages = Math.ceil(
    filteredClients.length /
    itemsPerPage
  );


  const paginatedClients =
    filteredClients.slice(

      (currentPage - 1) *
        itemsPerPage,

      currentPage *
        itemsPerPage

    );


  const goToPage = (page) => {

    if (
      page >= 1 &&
      page <= totalPages
    ) {

      setCurrentPage(page);

    }

  };


  // =========================
  // AJOUTER CLIENT
  // =========================

  const handleOpenAdd = () => {

    setClientEdit(null);

    setFormOpen(true);

  };


  // =========================
  // MODIFIER CLIENT
  // =========================

  const onEdit = (client) => {

    setClientEdit(client);

    setFormOpen(true);

  };


  // =========================
  // SUPPRIMER CLIENT
  // =========================

  const onDelete = async (id) => {

    if (
      window.confirm(
        "Voulez-vous supprimer ce client ?"
      )
    ) {

      try {

        await deleteClient(id);

        await loadClients();

      } catch (error) {

        console.error(
          "Erreur suppression client :",
          error
        );

      }

    }

  };


  // =========================
  // AJOUT / MODIFICATION
  // =========================

  const onSubmit = async (data) => {

    try {

      if (clientEdit) {

        await updateClient(
          clientEdit.id,
          data
        );

      } else {

        await createClient(data);

      }


      await loadClients();


      setFormOpen(false);

      setClientEdit(null);


    } catch (error) {

      console.error(
        "Erreur lors de l'enregistrement client :",
        error
      );

    }

  };


  // =========================
  // FERMER FORMULAIRE
  // =========================

  const handleCloseForm = () => {

    setFormOpen(false);

    setClientEdit(null);

  };


  // =========================
  // EFFACER RECHERCHE
  // =========================

  const clearSearch = () => {

    setSearchClient("");

    setCurrentPage(1);

  };


  // =========================
  // AFFICHAGE
  // =========================

  return (

    <div className="clients-page">


      {/* =========================
          TITRE
      ========================== */}

      <div className="clients-header">

        <div>

          <h1>
            Gestion des Clients
          </h1>

          <p className="clients-subtitle">
            Gestion et recherche des clients
          </p>

        </div>


        <button
          onClick={handleOpenAdd}
          className="btn-add"
        >
          + Ajouter un client
        </button>

      </div>


      {/* =========================
          FORMULAIRE
      ========================== */}

      {formOpen && (

        <div className="form-container open">

          <ClientForm
            onSubmit={onSubmit}
            client={clientEdit}
          />


          <button
            onClick={handleCloseForm}
            className="btn-close"
          >
            Fermer
          </button>

        </div>

      )}


      {/* =========================
          RECHERCHE
      ========================== */}

      <div className="clients-toolbar">


        <div className="client-search">


          <span className="search-icon">
            🔍
          </span>


          <input
            type="text"
            value={searchClient}
            onChange={(e) =>
              setSearchClient(
                e.target.value
              )
            }
            placeholder="Rechercher un client par nom, téléphone ou email..."
          />


          {searchClient && (

            <button
              type="button"
              className="search-clear"
              onClick={clearSearch}
              title="Effacer la recherche"
            >
              ✕
            </button>

          )}

        </div>


        <div className="clients-count">

          <strong>
            {filteredClients.length}
          </strong>

          {" "}

          client
          {filteredClients.length !== 1
            ? "s"
            : ""}

        </div>


        {searchClient && (

          <div className="search-result-text">

            Résultat pour :

            {" "}

            <strong>
              "{searchClient}"
            </strong>

          </div>

        )}

      </div>


      {/* =========================
          TABLEAU
      ========================== */}

      {filteredClients.length > 0 ? (

        <ClientTable

          clients={paginatedClients}

          onEdit={onEdit}

          onDelete={onDelete}

        />

      ) : (

        <div className="no-clients">

          <div className="no-clients-icon">
            🔍
          </div>

          <h3>
            Aucun client trouvé
          </h3>

          <p>
            Aucun client ne correspond à votre recherche.
          </p>


          {searchClient && (

            <button
              type="button"
              className="btn-reset-search"
              onClick={clearSearch}
            >
              Réinitialiser la recherche
            </button>

          )}

        </div>

      )}


      {/* =========================
          PAGINATION
      ========================== */}

      {totalPages > 1 && (

        <div className="pagination">


          <button
            onClick={() =>
              goToPage(
                currentPage - 1
              )
            }
            disabled={
              currentPage === 1
            }
          >
            ← Précédent
          </button>


          {Array.from(
            {
              length: totalPages
            },
            (_, index) => {

              const page = index + 1;

              return (

                <button
                  key={page}
                  className={
                    currentPage === page
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    goToPage(page)
                  }
                >
                  {page}
                </button>

              );

            }
          )}


          <button
            onClick={() =>
              goToPage(
                currentPage + 1
              )
            }
            disabled={
              currentPage ===
              totalPages
            }
          >
            Suivant →
          </button>


        </div>

      )}


      {/* =========================
          INFORMATION PAGINATION
      ========================== */}

      {filteredClients.length > 0 && (

        <div className="pagination-info">

          Affichage de{" "}

          <strong>
            {(currentPage - 1) *
              itemsPerPage + 1}
          </strong>

          {" "}à{" "}

          <strong>
            {Math.min(
              currentPage *
                itemsPerPage,
              filteredClients.length
            )}
          </strong>

          {" "}sur{" "}

          <strong>
            {filteredClients.length}
          </strong>

          {" "}client
          {filteredClients.length !== 1
            ? "s"
            : ""}

        </div>

      )}

    </div>

  );

}